import React from 'react';

import Slider from '@material-ui/core/Slider';

const marks = [
  {
    value: 0,
    label: '$0',
  },
  {
    value: 5,
    label: '$5m+',
  },
  {
    value: 10,
    label: '$10m+',
  },
  {
    value: 100,
    label: '$100m',
  },
];

const marks2 = [
  {
    value: 0,
    label: '$0',
  },
  {
    value: 25,
    label: '$250k+',
  },
  {
    value: 50,
    label: '$500k+',
  },
  {
    value: 100,
    label: '$1000k',
  },
];

function valuetext(value) {
  return `${value}`;
}

export default function RangeSlider({setRange, type}) {
  const [value, setValue] = React.useState([0, 50]);

  const handleChange = (event, newValue) => {
    console.log(newValue)
    setRange(newValue)
    setValue(newValue);
  };

  return (
    <div className='px-0 col-md-4  col-xl-3'>
      <Slider
        value={value}
        onChange={handleChange}
        aria-labelledby='range-slider'
        getAriaValueText={valuetext}
        marks={type === 'real'? marks2  : marks}
      />
    </div>
  );
}
